export const DEFAULT_ZOOM_SCALE = 1.5;